import { useState, type FormEvent } from "react";
import { useTranslation } from "react-i18next";
import AutocompleteInput from "./AutocompleteInput";

interface Props {
  onSubmit: (company: string, years: number) => void;
  disabled: boolean;
}

export default function SearchForm({ onSubmit, disabled }: Props) {
  const [company, setCompany] = useState("");
  const [years, setYears] = useState(5);
  const { t } = useTranslation();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const trimmed = company.trim();
    if (!trimmed) return;
    onSubmit(trimmed, years);
  };

  return (
    <form onSubmit={handleSubmit} className="mb-8 max-md:mb-5">
      <div className="hidden max-md:flex items-center gap-2 mb-3">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2.5">
          <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
        </svg>
        <span className="text-sm font-semibold text-zinc-700 dark:text-zinc-300">{t("common.analyze")}</span>
      </div>

      <div className="flex items-center bg-white dark:bg-zinc-900 border-2 border-zinc-200 dark:border-zinc-700 rounded-2xl pl-5 pr-1.5 py-1.5 gap-2 transition-colors focus-within:border-indigo-500 focus-within:ring-3 focus-within:ring-indigo-500/15 shadow-sm max-md:flex-col max-md:p-3 max-md:rounded-xl">
        <svg className="text-zinc-400 shrink-0 max-md:hidden" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
        </svg>
        <AutocompleteInput
          value={company}
          onChange={setCompany}
          placeholder={t("home.searchPlaceholder")}
          disabled={disabled}
          className="w-full py-3.5 px-2 border-none bg-transparent text-zinc-950 dark:text-white text-base outline-none font-[inherit] placeholder:text-zinc-400 max-md:py-3 max-md:text-sm"
        />
        <select
          value={years}
          onChange={(e) => setYears(Number(e.target.value))}
          className="py-2.5 px-3 border border-zinc-200 dark:border-zinc-800 rounded-[10px] bg-zinc-50 dark:bg-zinc-800 text-zinc-700 dark:text-zinc-300 text-sm cursor-pointer font-[inherit] outline-none max-md:w-full"
        >
          <option value={3}>3년</option>
          <option value={5}>5년</option>
          <option value={7}>7년</option>
        </select>
        <button
          type="submit"
          disabled={disabled}
          className="py-3.5 px-7 border-none rounded-xl bg-indigo-500 text-white text-[15px] font-semibold cursor-pointer whitespace-nowrap font-[inherit] transition-colors hover:bg-indigo-600 disabled:bg-zinc-200 dark:disabled:bg-zinc-800 disabled:text-zinc-400 disabled:cursor-not-allowed max-md:w-full max-md:rounded-[10px] max-md:py-3.5 max-md:text-base"
        >
          {t("common.analyze")}
        </button>
      </div>
    </form>
  );
}
